<template>
  <div class="index">
    <div class="index_header">
      <div class="index_header_main">
        <img src="../assets/images/logo_kuaigui.png" alt="">
      </div>
    </div>
    <div class="index_content">
      <img src="../assets/images/pc/01.png" alt="">
      <div class="index_content_button">
        <div>
          <button @click="iosDownload">iOS版本下载</button>
          <button  @click="androidDownload">安卓版本下载</button>
        </div>
      </div>
      <img src="../assets/images/pc/02.png" alt="">
      <img src="../assets/images/pc/03.png" alt="">
      <img src="../assets/images/pc/04.png" alt="">
      <img src="../assets/images/pc/05.png" alt="">
    </div>
    <div class="index_footer">
      <div class="index_footer_main">
        <span><a href="http://www.beian.miit.gov.cn" target="_blank">皖ICP备18008562号-2</a> 快龟共享车位</span>
        <span>增值电信业务许可证：B2-20190353</span>
        <span>皖网文[2019]3163-136号</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Index",
    created() {
      if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) { //移动端
        window.console.log('手机端');
        this.$router.replace({
          path:'/mobile'
        });
      }
    },
    methods:{
      iosDownload:function(){
        window.open("https://apps.apple.com/cn/app/%E5%BF%AB%E9%BE%9F-%E6%89%BE%E8%BD%A6%E4%BD%8D-%E4%B8%8A%E5%BF%AB%E9%BE%9F/id1483412143","_blank");
        // window.location.href = 'https://apps.apple.com/cn/app/%E5%BF%AB%E9%BE%9F-%E6%89%BE%E8%BD%A6%E4%BD%8D-%E4%B8%8A%E5%BF%AB%E9%BE%9F/id1483412143';
      },
      androidDownload:function(){
        window.open("https://android.myapp.com/myapp/detail.htm?apkName=com.kuaigui.intelligentlock","_blank");
        // window.location.href='https://android.myapp.com/myapp/detail.htm?apkName=com.kuaigui.intelligentlock';
      }
    }
  }
</script>

<style lang="scss" type="text/scss">
  .index{
    width: 100%;
    height: 100%;
    font-size: 16px;
    background-color: #fff;
    overflow: auto;
    color: #333;
    &_header{
      background-color: #f6f7f8;
      min-width: 1000px;
      &_main{
        max-width: 1440px;
        height: 80px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        padding-left: 30px;
        img{
          width: 220px;
        }
      }
    }
    &_content{
      max-width: 1440px;
      min-width: 1000px;
      margin: 0 auto;
      &_button{
        margin-top: -100px;
        margin-bottom: 100px;
        div{
          position: relative;
          width: 500px;
          margin: 0 auto;
        }
        button{
          width: 230px;
          height: 50px;
          color: #fff;
          border: none;
          border-radius: 4px;
          margin: 0 auto;
          cursor: pointer;
          font-size: 18px;
          &:first-child{
            background-color: #5e76ff;
            margin-right: 40px;
          }
          &:last-child{
            background-color: #1ace77;
          }
        }
      }
      img{
        width: 100%;
        display: block;
      }
    }
    &_footer{
      min-width: 1000px;
      background-color: #f6f7f8;
      text-align: center;
      color: #6f7786;
      span,a{
        margin: 0 10px;
        color: #6f7786;
      }
    }
  }
  @media screen and (max-width: 1440px) {
    .index_footer {
      font-size: 1.44vw;
      height: 7.353vw;
      line-height: 7.353vw;
    }
  }
  @media screen and (max-width: 1024px) {
    .index_footer {
      font-size: 14px;
      height: 74px;
      line-height: 74px;
    }
  }
  @media screen and (min-width: 1440px) {
    .index_footer {
      font-size: 21px;
      height: 100px;
      line-height: 100px;
    }
  }

</style>